import { render } from "./CallHistory.vue?vue&type=template&id=fe62398e&ts=true"
import script from "./CallHistory.ts?vue&type=script&lang=ts&external"
export * from "./CallHistory.ts?vue&type=script&lang=ts&external"

import "./CallHistory.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__